import * as Yup from "yup";
import {
  cpf,
  email,
  name,
  password,
  phone,
  secondPassword,
  term_of_contract,
} from "../YupSchema";

export interface ISignUp {
  name: string;
  document_nr: string;
  cell_phone: string;
  email: string;
  password: string;
  secondPassword?: string;
  term_of_contract?: boolean;
  client_ip: string;
  whitelabel_id: number | null;
}

export const validationSignUp = Yup.object().shape({
  name: name,
  document_nr: cpf,
  email: email,
  cell_phone: phone,
  password: password,
  secondPassword: secondPassword,
  term_of_contract: term_of_contract,
});
